import store from '@/store'
import { getData } from '@core/utils/http/general'

//* Make http request to get info by course id
export const cursoInfo = idCurso => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 4,
    curso: idCurso,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wscursos')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        const { curso, recursos, parciales } = response.data
        resolve({ curso, recursos, parciales })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Return resource list
export const resourceList = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 8,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wscursos')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        // const { curso, recursos, parciales } = response.data
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Return days list
export const dayList = () => {
  const semana = [
    { value: 1, text: 'Lunes' },
    { value: 2, text: 'Martes' },
    { value: 3, text: 'Miércoles' },
    { value: 4, text: 'Jueves' },
    { value: 5, text: 'Viernes' },
    { value: 6, text: 'Sábado' },
    { value: 7, text: 'Domingo' },
  ]

  return {
    semana,
  }
}
